// Чистая логика зума/пана холста детали.
// Экранные px канваса = локальные px стейджа · zoom + pan.
import { clamp } from "./geom.js"

// Зум к точке: точка контента под курсором остаётся на том же экранном месте.
// view={zoom,panX,panY}, pointer={x,y} (px канваса), factor — множитель (>1 приблизить).
export function zoomToPoint(view, pointer, factor, { min = 1, max = 8 } = {}) {
  const zoom = clamp(view.zoom * factor, min, max)
  const lx = (pointer.x - view.panX) / view.zoom
  const ly = (pointer.y - view.panY) / view.zoom
  return { zoom, panX: pointer.x - lx * zoom, panY: pointer.y - ly * zoom }
}

// Кламп пана: контент крупнее холста — без пустых полей; мельче — по центру.
// contentBox={x,y,w,h} в локальных px (bbox детали в px = fit).
export function clampPan(view, canvas, contentBox) {
  const axis = (pan, canvasLen, boxStart, boxLen) => {
    const min = canvasLen - (boxStart + boxLen) * view.zoom
    const max = -boxStart * view.zoom
    if (min > max) return (canvasLen - boxLen * view.zoom) / 2 - boxStart * view.zoom
    return clamp(pan, min, max)
  }
  return {
    panX: axis(view.panX, canvas.width, contentBox.x, contentBox.w),
    panY: axis(view.panY, canvas.height, contentBox.y, contentBox.h),
  }
}
